import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function HomeQuickQualifier() {
  const idealFor = ['Doing $1M+ in annual revenue.', 'Teams with 5+ reps who want to grow aggressively.', 'Leaders who want a system, not a magic pill.', 'Organizations willing to lead, not just hire.'];
  return <section className="section-padding bg-navy text-white" data-id="element-456">
      <div className="container-custom" data-id="element-457">
        <div className="max-w-4xl mx-auto" data-id="element-458">
          <div className="text-center mb-8 md:mb-10 lg:mb-12" data-id="element-459">
            <h2 className="text-white mb-3 md:mb-4 lg:mb-6" data-id="element-460">
              Who We Work With
            </h2>
            <p className="text-body-large text-gray-300 leading-relaxed" data-id="element-461">
              We are not for everyone. We work best with D2D and direct sales
              teams who fit this profile:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-3 md:gap-4 lg:gap-6 mb-8 md:mb-10 lg:mb-12" data-id="element-462">
            {idealFor.map((item, index) => <div key={index} className="flex items-start bg-navy-light rounded p-4 md:p-5 lg:p-6 border border-gray-700" data-id="element-463">
                <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-slate flex-shrink-0 mr-2 md:mr-3 mt-0.5" data-id="element-464" />
                <span className="text-gray-200" data-id="element-465">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-466">
            <p className="text-gray-300 mb-4 md:mb-6" data-id="element-467">
              If that sounds like you, let's talk.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center" data-id="element-468">
              <a href="/who-we-serve" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-navy font-bold px-6 md:px-8 py-3 md:py-4 rounded transition-colors text-sm" data-id="element-469">
                See Who We Serve{' '}
                <ArrowRightIcon className="ml-2 h-4 w-4 md:h-5 md:w-5" data-id="element-470" />
              </a>
              <a href="/book-call" className="inline-block bg-slate hover:bg-slate-dark text-white font-bold px-6 md:px-8 py-3 md:py-4 rounded transition-colors shadow-lg text-sm" data-id="element-471">
                Book Your Strategy Call →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}